<template>
  <div id="my-title" :class="[isParticular ? 'particular' : '']">
    <div class="title">{{ title }}</div>
    <div class="operation">
      <div
        v-if="!isParticular"
        class="header-icon download-icon"
        title="下载"
        @click="changeShowExportProgress(true)"
      ></div>
      <div v-if="isRunningInElectron" class="header-icon menu-icon" title="菜单" @click="getOpenMenu"></div>
      <div
        v-if="isRunningInElectron"
        :class="['header-icon', isFullScreen ? 'exist-fullscreen-icon' : 'fullscreen-icon']"
        :title="isFullScreen ? '退出全屏' : '全屏'"
        @click="toggleMode"
      ></div>
      <div v-if="isRunningInElectron" class="header-icon mini-icon" title="最小化" @click="minimizeWin"></div>
      <div class="header-icon close-icon" title="关闭" @click="closeWin"></div>

      <!-- 菜单弹框 -->
      <div v-if="showMenu" class="menu-box-mask" @click="showMenu = false" />
      <div v-if="showMenu" class="menu-box">
        <div class="menu-box-left">
          <div class="left-title">客户端版本</div>
          <div class="content">
            <div class="current-release">v {{ currentRelease }}</div>
            <div v-if="isNewVersion" class="new-version">有新版本</div>
          </div>
        </div>
        <div class="menu-box-right" @click="checkClientVersion(true)">检查更新</div>
      </div>
      <!--  下载中心    -->
      <div v-if="showExportProgress" class="export-box-mask" @click="changeShowExportProgress(false)" />
      <div v-if="showExportProgress" class="export-box">
        <div class="export-box-title">近期下载</div>
        <div v-for="item in exportData" :key="item.id" class="export-box-row">
          <div class="img-box">
            <img src="@/assets/common/excel.png" />
          </div>
          <div class="name-time">
            <div class="name">{{ item.remark }}</div>
            <div class="time">{{ item.requestAt }}</div>
          </div>
          <div class="status-box" @click="handleStatusClick(item)">
            <img
              :class="[item.taskStatus === 'RUNNING' ? 'rotate' : '']"
              :src="require(`@/assets/bar/${exportTaskStatusMap[item.taskStatus]?.icon}.png`)"
            />
            {{ exportTaskStatusMap[item.taskStatus]?.tip }}
          </div>
        </div>
      </div>
    </div>
    <EditPassword ref="editPassword" />

    <!-- 版本更新弹框 -->
    <CheckVersionModal ref="checkVersionModalRef" />
    <!-- 静默下载后确认安装弹窗 -->
    <InstallUpdateModal ref="installUpdateModalRef" />
  </div>
</template>

<script>
import { title, exportTaskStatusMap } from '@/utils/dictionary'
import EditPassword from '@/components/common/EditPassword'
import { message } from 'ant-design-vue'
import { compareVersion } from '@/utils/versionUtils'
import { checkVersion } from '@/api/common'
import { isRunningInElectron } from '@/utils/electronUtils'
import { pageList } from '@/api/homeworkReport'
import CheckVersionModal from '@/components/common/CheckVersionModal.vue'
import InstallUpdateModal from '@/components/common/InstallUpdateModal.vue'

export default {
  // 自定义标题栏
  name: 'MyTitle',
  components: { CheckVersionModal, EditPassword, InstallUpdateModal },
  data() {
    return {
      exportTaskStatusMap,
      isParticular: false, // 是否为特殊情况
      title,
      showClass: false,
      showMenu: false, // 是否显示菜单
      currentRelease: '', // 当前版本
      isNewVersion: false, // 是否有新版本
      isUpdate: false, // 是否在更新版本中
      progress: 0, // 更新进度
      isRunningInElectron: false,
      exportData: [],
      times: 0, // 轮询获取导出任务状态 3s一次 30s之后停止轮询
      timer: null, // 获取导出任务定时器
      isFullScreen: true // 与electron/background.js中创建主窗口的fullscreen一致
    }
  },
  computed: {
    // 最大化状态
    maximized() {
      return this.$store.getters.maximized
    },
    // 最小化状态
    minimized() {
      return this.$store.getters.maximized
    },
    token() {
      return this.$store.getters.token
    },
    // 最小化状态
    userName() {
      return this.$store.getters.userName
    },
    // 最小化状态
    schoolName() {
      return this.$store.getters.userInfo ? this.$store.getters.userInfo.schoolName : ''
    },
    showExportProgress() {
      return this.$store.getters.showExportProgress
    }
  },
  watch: {
    $route: {
      handler(to) {
        this.isParticular = to?.meta?.isParticular
        if (isRunningInElectron() && this.$route.name === 'Login') {
          this.autoCheckClientVersion()
        }
        // 检查是否有已下载好的安装包，且本次会话未提示过
        //const noBindDTQ = JSON.parse(sessionStorage.getItem('noBindDTQ') ?? 'true')
        const hasPromptedUpdate = this.$store.state.app.hasPromptedUpdate
        // 没绑答题器：直接上课，进首页时弹
        if (isRunningInElectron() && ['HomeV2', 'Home'].includes(to.name) && !hasPromptedUpdate) {
          this.checkUpdateReady()
        }
        // 绑了答题器：绑定完成后用户仍在选班页，在此弹
        // if (isRunningInElectron() && ['ChooseClassV2', 'ChooseClass'].includes(to.name) && !noBindDTQ && !hasPromptedUpdate) {
        //   this.checkUpdateReady()
        // }
      },
      immediate: true
    },
    showExportProgress(val) {
      if (val) {
        this.getExportData()
      } else {
        if (this.timer) {
          clearTimeout(this.timer)
        }
      }
    }
  },
  created() {
    // 当程序在 electron 里时，接收electron 主进程发送的函数
    this.isRunningInElectron = isRunningInElectron()
    if (isRunningInElectron()) {
      // 获取当前客户端版本
      this.currentRelease = window.electron.versions.app
      // 渲染进程接收主进程（background.js）传递函数
      // 是否进入全屏状态
      window.electron.onCreateBrowserView('enterFullScreen', (_, isFullScreen) => {
        this.isFullScreen = isFullScreen
      })
      // 是否最大化窗口
      window.electron.onCreateBrowserView('mainWinMax', (_, status) => {
        this.$store.commit('window/SMART_TEACHING_SYSTEM_MAXIMIZED', status)
      })
      // 是否最小化窗口
      window.electron.onCreateBrowserView('mainWinMin', (_, status) => {
        this.$store.commit('window/SMART_TEACHING_SYSTEM_MINIMIZED', status)
      })
      // 调整窗口大小后
      window.electron.onCreateBrowserView('resized', (_, data) => {
        this.$store.commit('window/SMART_TEACHING_SYSTEM_WINDOW_SIZE', data)
      })
      // 告诉主进程，web已初始化
      window.electron.ipcRenderer.send('web-init')
    }
  },
  methods: {
    // 打开菜单
    getOpenMenu() {
      this.showMenu = !this.showMenu
    },
    toggleMode() {
      window.electron.ipcRenderer.send('window-mode-toggle')
    },
    // 检查本地是否有已下载好的安装包，有则弹出安装确认弹窗
    async checkUpdateReady() {
      try {
        // 通过 offlinePath 推算 userData 目录，再拼接标记文件路径
        // offlinePath: C:\Users\xxx\AppData\Roaming\<app>\offline
        // flagPath:    C:\Users\xxx\AppData\Roaming\<app>\AppStorage\update-ready.json
        const offlinePath = await window.electron.getUserDataOfflinePath()
        const userDataPath = offlinePath.replace(/[/\\]offline$/, '')
        const flagPath = userDataPath + '\\AppStorage\\update-ready.json'
        const fileData = await window.electron.fs.readFileData(flagPath)
        if (!fileData) return
        const flag = JSON.parse(Buffer.from(fileData).toString('utf-8'))
        if (!flag || !flag.version) return
        // 标记文件中的版本与当前运行版本相同，说明已经安装过了，清理缓存并跳过
        if (flag.version === this.currentRelease) {
          console.log('checkUpdateReady：标记版本与当前版本一致，清理缓存并跳过', flag.version)
          window.electron.ipcRenderer.send('clearUpdateCache')
          return
        }
        // 标记本次会话已提示，不再重复弹窗
        this.$store.commit('app/SET_HAS_PROMPTED_UPDATE', true)
        this.$refs.installUpdateModalRef.show({
          lastVersion: flag.version,
          upgradeMsg: flag.upgradeMsg || '',
          forceUpgrade: flag.forceUpgrade || false
        })
      } catch (e) {
        console.error('checkUpdateReady 异常', e)
      }
    },
    // 检查客户端版本（手动触发，有更新则弹窗）
    checkClientVersion(isClick) {
      checkVersion()
        .then(res => {
          const data = res.data
          // 有新版本时
          if (data.upgrade) {
            this.isNewVersion = true
            this.$refs.checkVersionModalRef.show(data)
          } else {
            if (isClick) {
              message.success('当前已经是最新版本了哦~', 1.5)
            }
          }
          this.showMenu = false
        })
        .catch(e => {
          if (e.toString() === 'Error: Network Error') {
            message.destroy()
            message.error('当前网络不稳定或无网络链接，请检查网络是否可用或选择离线应用')
          }
        })
    },
    // 自动检测版本（进入登录页触发，有更新则后台静默下载，不弹窗）
    autoCheckClientVersion() {
      checkVersion()
        .then(res => {
          const data = res.data
          if (data.upgrade) {
            this.isNewVersion = true
            // feedUrl 必须是目录路径，electron-updater 会自动拼接 latest.yml
            // downloadUrl 可能是完整文件路径如 .../2.3.8/xxx.exe，需截取到目录部分
            const lastSlash = data.downloadUrl.lastIndexOf('/')
            const feedUrl = lastSlash > 0 ? data.downloadUrl.substring(0, lastSlash) : data.downloadUrl
            // 通知主进程静默下载（主进程自行判断是否需要重新下载）
            window.electron.ipcRenderer.send('startSilentUpdateIfNeeded', {
              feedUrl,
              lastVersion: data.lastVersion,
              upgradeMsg: data.upgradeMsg || '',
              forceUpgrade: data.forceUpgrade || false
            })
          }
        })
        .catch(e => {
          if (e.toString() === 'Error: Network Error') {
            message.destroy()
            message.error('当前网络不稳定或无网络链接，请检查网络是否可用或选择离线应用')
          }
        })
    },
    // 弹框失去焦点
    divBlur() {
      this.showClass = false
    },
    changeShow() {
      this.showClass = true
      this.$nextTick(() => {
        this.$refs.classList.focus()
      })
    },
    // 通知主进程我要进行窗口最小化操作
    minimizeWin() {
      window.electron.ipcRenderer.send('window-min')
    },
    // 通知主进程我要进行最大化 或 还原
    maximizeWin() {
      window.electron.ipcRenderer.send('window-max')
      this.$bus.$emit('reSizeScreen', this.maximized)
    },
    // 通知主进程我要关闭
    closeWin() {
      const that = this
      const { meta } = this.$route
      if (meta.isHome) {
        if (isRunningInElectron()) {
          // this.$confirm({
          //   title: '温馨提示',
          //   content: '是否确认退出程序?',
          //   okText: '确认',
          //   okType: 'danger',
          //   cancelText: '取消',
          //   centered: true,
          //   onOk() {
          //     window.electron.ipcRenderer.send('window-hide')
          //   }
          // })
          window.electron.ipcRenderer.send('window-hide')
        } else {
          that.$confirm({
            title: '是否确认退出系统?',
            maskClosable: true,
            okText: '退出',
            cancelText: '返回',
            centered: true,
            onOk() {
              that.logout()
            }
          })
        }
      } else {
        if (meta.answer) {
          that.$confirm({
            title: '是否要退出做题?',
            maskClosable: true,
            okText: '退出',
            cancelText: '返回',
            centered: true,
            onOk() {
              that.$router.go(-1)
            }
          })
        } else if (meta.isPk) {
          //that.$confirm({
          //  title: '是否要退出PK?',
          //  maskClosable: true,
          //  okText: '退出',
          //  cancelText: '返回',
          //  centered: true,
          //  onOk() {
          //    sessionStorage.setItem('pkSelectedWordIds', JSON.stringify({}))
          //    sessionStorage.setItem('pkSelectedStudent', JSON.stringify([]))
          //    sessionStorage.setItem('pkSelectedWords', JSON.stringify([]))
          //    sessionStorage.setItem('openDialog', JSON.stringify(false))
          //    that.$router.go(-1)
          //  }
          //})
          sessionStorage.setItem('pkSelectedWordIds', JSON.stringify({}))
          sessionStorage.setItem('pkSelectedStudent', JSON.stringify([]))
          sessionStorage.setItem('pkSelectedWords', JSON.stringify([]))
          sessionStorage.setItem('openDialog', JSON.stringify(false))
          //that.$router.go(-1)
          that.$router.replace({ name: 'CreatePk' })
        } else {
          // that.$confirm({
          //   title: '是否确认退出系统?',
          //   maskClosable: true,
          //   okText: '退出',
          //   cancelText: '返回',
          //   centered: true,
          //   onOk() {
          //     if (isRunningInElectron()) {
          //       window.electron.ipcRenderer.send('window-hide')
          //     } else {
          //       that.logout()
          //     }
          //   }
          // })
          if (isRunningInElectron()) {
            window.electron.ipcRenderer.send('window-hide')
          } else {
            that.logout()
          }
        }
      }
    },
    // 修改密码
    editPassword() {
      this.$refs.editPassword.changeVisible(true)
    },
    // 退出登录
    async logout() {
      this.showClass = false
      await this.$store.dispatch('user/logout')
      // 清除临时缓存的单词作答记录
      sessionStorage.removeItem('wordAnswerStorage')
      sessionStorage.removeItem('pkSelectedWordIds')
      sessionStorage.removeItem('pkSelectedWords')
      sessionStorage.removeItem('pkSelectedStudent')
      this.$router.push({ name: 'Login', query: { quit: '1' } })
    },
    changeShowExportProgress(bol) {
      this.$store.dispatch('app/setShowExportProgress', bol)
    },
    getExportData() {
      pageList({
        page: 1,
        pageSize: 10,
        createUid: this.$store.getters.userId,
        taskType: 1,
        taskBizType: 'PRIMARY_EXPORT_HOMEWORK_ITEM_SCORE',
        userId: this.$store.getters.userId,
        source: 203
      }).then(res => {
        this.exportData = res.data.pageContents
        if (this.exportData.some(el => el.taskStatus === 'RUNNING')) {
          if (this.times === 10) {
            this.$message.error('准备超时，请检查网络是否通畅')
            return
          }
          this.timer = setTimeout(this.getExportData, 3000)
          this.times++
        }
      })
    },
    handleStatusClick(item) {
      if (item.taskStatus === 'FINISHED') {
        const downloadElement = document.createElement('a')
        downloadElement.href = item.resultUrl
        downloadElement.download = name
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        this.changeShowExportProgress(false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#my-title {
  bottom: 40px;
  z-index: 9999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  background: transparent;

  &.particular {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: transparent;
  }

  .title {
    margin-left: 25px;
    color: #171c14;
    font-size: 20px;
    font-weight: bold;

    &.particular {
      color: #ffffff;
    }
  }
  .school {
    margin-top: 10px;
    line-height: 28px;
    height: 50px;
    color: #333333;
    font-size: 20px;
    padding: 11px 40px;
    border-radius: 0 0 20px 20px;
    background: linear-gradient(90deg, #c1dbff 0%, #ffe5c8 100%);
    z-index: 2;
    position: relative;
    display: flex;
    align-items: center;
    .bar-school-icon {
      width: 50px;
      height: 40px;
      position: absolute;
      top: 0;
      &.school-left {
        left: -50px;
      }
      &.school-right {
        right: -50px;
      }
    }
    .school-icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }

  .header-icon {
    width: 25px;
    height: 25px;
    background-size: 100% 100%;
    cursor: pointer;
    &.download-icon {
      background-image: url('@/assets/header/download.png');
      margin-right: 23px;
    }

    &.menu-icon {
      background-image: url('@/assets/header/menu.png');
      margin-right: 23px;
    }

    &.fullscreen-icon {
      background-image: url('@/assets/header/fullscreen.png');
      margin-right: 23px;
    }

    &.exist-fullscreen-icon {
      background-image: url('@/assets/header/exist-fullscreen.png');
      margin-right: 23px;
    }

    &.mini-icon {
      background-image: url('@/assets/header/minimize.png');
      margin-right: 23px;
    }

    &.close-icon {
      background-image: url('@/assets/header/close.png');
      margin-right: 25px;
    }
  }

  .operation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    -webkit-app-region: no-drag;

    .user {
      position: relative;
      height: 100%;
      z-index: 2000;

      .class-list {
        position: absolute;
        top: 40px;
        right: -80px;
        width: 410px;
        font-size: 17px;
        line-height: 24px;
        color: #333333;
        z-index: 2;
        background: #ffffff;
        border-radius: 0 0 32px 32px;
        box-shadow: 0 20px 50px 0 rgba(0, 0, 0, 0.3);
        outline: none;
        .user-info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 20px 0 14px;
          margin: 0 28px;
          border-bottom: 1px solid #e5e5e5;

          span {
            font-size: 17px;
            font-weight: 400;
            color: #333333;
          }
        }

        .class-content {
          min-height: 60px;
          max-height: 350px;
          overflow-y: auto;
          padding: 0 28px;

          .class-item {
            margin-top: 10px;
            background: #f6f6f6;
            height: 50px;
            padding: 13px 14px;
            border-radius: 8px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &.active {
              color: #1976ff;
            }

            &:hover {
              background: #f1f1f1;
            }

            .item-id {
              font-size: 17px;
              line-height: 20px;
            }

            .select-img {
              width: 20px;
              height: 20px;
            }
          }
        }

        .module-content {
          margin: 20px 0 28px;
          padding: 0 28px;
          display: flex;
          //justify-content: space-between;
          justify-content: center;
          align-items: center;

          .edit-password {
            width: 170px;
            height: 76px;
            background: rgba(25, 118, 255, 0.1);
            border-radius: 12px;
            font-size: 17px;
            font-weight: 400;
            color: #1976ff;

            .change-password-icon {
              width: 72px;
              height: 76px;
            }

            &:hover,
            &:active {
              background: rgba(25, 118, 255, 0.2);
            }
          }

          .logout {
            width: 170px;
            //width: 100%;
            height: 76px;
            background: rgba(255, 60, 48, 0.1);
            border-radius: 12px;
            font-size: 17px;
            font-weight: 400;
            color: #ff3c30;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 20px;

            .login-out-icon {
              width: 72px;
              height: 76px;
            }

            .text {
              //margin-left: 10px;
            }

            .right-arrow {
              width: 6px;
              height: 11px;
            }

            &:hover,
            &:active {
              background: rgba(255, 60, 48, 0.2);
            }
          }
        }
      }
    }
  }

  .menu-box-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: transparent;
    z-index: 9998;
  }
  .menu-box {
    position: fixed;
    top: 40px;
    right: 100px;
    z-index: 9999;

    display: flex;
    align-items: center;
    justify-content: center;
    width: 304px;
    height: 100px;
    background: #ffffff;
    box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
    border-radius: 24px;
    border: 1px solid #e5e5e5;

    .menu-box-left {
      .left-title {
        text-align: left;
        font-size: 19px;
        font-weight: 400;
        color: #333333;
        line-height: 26px;
      }

      .content {
        margin-top: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-weight: 400;
        color: #333333;
        line-height: 21px;

        .new-version {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 8px;
          width: 64px;
          height: 21px;
          background: #f6f6f6;
          border-radius: 24px;
          font-size: 12px;
          font-weight: 400;
          color: #ff3c30;
          line-height: 17px;
        }
      }
    }

    .menu-box-right {
      margin-left: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100px;
      height: 40px;
      background: linear-gradient(270deg, #66adff 0%, #1976ff 100%);
      border-radius: 100px;
      font-size: 17px;
      font-weight: 400;
      color: #ffffff;
      line-height: 24px;

      &:hover {
        background: #0565f3;
      }
    }
  }

  .export-box-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: transparent;
    z-index: 9998;
  }
  .export-box {
    position: fixed;
    top: 40px;
    right: 60px;
    z-index: 9999;
    width: 400px;
    background: #ffffff;
    box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
    border-radius: 24px;
    border: 1px solid #e5e5e5;
    padding: 20px;

    .export-box-title {
      font-weight: 600;
      font-size: 20px;
      color: #333333;
      padding-bottom: 16px;
      border-bottom: 1px solid #f1f1f1;
    }

    .export-box-row {
      display: flex;
      align-items: center;
      margin-top: 20px;
      .img-box {
        width: 56px;
        height: 56px;
        background: linear-gradient(180deg, #e8f1ff 0%, #f1f1f1 100%);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        img {
          width: 30px;
          height: 30px;
        }
      }
      .name-time {
        flex: 1;
        overflow: hidden;
        .name {
          font-weight: 600;
          font-size: 19px;
          color: #333333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .time {
          font-weight: 400;
          font-size: 14px;
          color: #999999;
        }
      }
      .status-box {
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-left: 12px;
        cursor: pointer;
        img {
          width: 20px;
          height: 20px;
          margin-bottom: 6px;
        }
        .rotate {
          animation: rotation 2s linear infinite;
          @keyframes rotation {
            from {
              transform: rotate(0);
            }

            to {
              transform: rotate(360deg);
            }
          }
        }
      }
    }
  }
}
</style>
